import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'sentry-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class EmptyStateComponent {
  @Input() title!: string;
  @Input() actionTitle!: string;
  @Input() imgSrc: string | null = null;
  @Output() actionClick$ = new EventEmitter();

  click() {
    this.actionClick$.emit();
  }
}
